'use strict';

/**
 * @extends {ngtk.model.List}
 */
ngtk.model.SlicedList = ngtk.model.List.extend({

    DEFAULT_PER_PAGE: 10,

    _slice: {},

    _initialize: function() {
        this.parent._initialize.call(this);
        this._resetSlice();
    },

    _resetSlice: function() {
        this._slice = {
            count: 0,
            limit: this.DEFAULT_PER_PAGE,
            page: 1,
            pages: 0
        };
    },

    _loadFromApi: function(method, args) {
        args = args || {};
        if (angular.isUndefined(args.per_page)) {
            args.per_page = this._slice.limit;
        }
        if (angular.isUndefined(args.page)) {
            args.page = this._slice.page - 1;
        }
        return this.parent._loadFromApi.call(this, method, args);
    },

    setPerPage: function(limit) {
        this._slice.limit = limit;
        return this;
    },

    setPage: function(page) {
        this._slice.page = page;
        return this;
    },

    getPage: function() {
        return this._slice.page;
    },

    load: function(page) {
        if (page) {
            this.setPage(page);
        }
        return this._load.apply(this, Array.prototype.slice.call(arguments, 1));
    },

    _load: function() {
        Class.abstractMethod();
    },

    _setFromApiResult: function(apiResultData, replace) {
        var list = angular.isDefined(apiResultData) && angular.isDefined(apiResultData['List'])
            ? apiResultData['List'] : [];
        this.parent._setFromApiResult.call(this, list, replace);
        this._setSliceDataFromApiResult(apiResultData);
    },

    _setSliceDataFromApiResult: function(apiResultData) {
        if (!apiResultData) {
            this._resetSlice();
            return;
        }
        this._slice.count = apiResultData['count'] || 0;
        this._slice.limit = apiResultData['per_page'] || 0;
        this._slice.page = apiResultData['display_page'] || 0;
        this._slice.pages = Math.ceil(this._slice.count / this._slice.limit);
    },

    _wireScope: function(scope, scopeInnerPtr, scopeInnerElement) {
        this.parent._wireScope.call(this, scope, scopeInnerPtr, scopeInnerElement);
        scopeInnerPtr[scopeInnerElement]['slice'] = this._slice;
    }

});
